import React from 'react';
import './upgrade.css';
import {
  TURBO_PLAN_AI_REQUEST_LIMIT,
  TURBO_PLAN_CODEBASES_INDEXED,
  TURBO_PLAN_CODEBASE_CONTEXT_FILE_LIMIT,
} from '../const';

const TurboPlanDescription = () => {
  const numRequestsLabel =
    TURBO_PLAN_AI_REQUEST_LIMIT === Infinity
      ? 'Unlimited'
      : TURBO_PLAN_AI_REQUEST_LIMIT;

  return (
    <div className="upgrade-plan-description">
      <div className="upgrade-discount-badge">
        Teams of 3+ get a 25% discount
      </div>
      <br />
      For users who want to maximize their AI capabilities, and collaborate and
      streamline ops. Get everything in Pro, plus:
      <ul>
        <li>{numRequestsLabel} premium Warp AI requests per user per month</li>
        <li>
          {TURBO_PLAN_CODEBASES_INDEXED} indexed codebases, up to{' '}
          {TURBO_PLAN_CODEBASE_CONTEXT_FILE_LIMIT} files / codebase
        </li>
        <li>Pay-as-you-go AI overages</li>
        <li>Unlimited access to Lite models</li>
        <li>Private email support</li>
      </ul>
    </div>
  );
};

export default TurboPlanDescription;
